export default __webpack_public_path__ + "static/media/Union2.9d551c59.svg";